import { FirebaseError } from 'firebase/app';

/**
 * Extracts a readable message from an unknown thrown value (Firebase errors,
 * native Errors, or anything else). Use this in `catch (err: unknown)` blocks
 * instead of typing the catch variable as `any`.
 */
export function getErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (error instanceof FirebaseError) return error.message;
  if (error instanceof Error) return error.message;
  return fallback;
}

/** Returns the Firebase error code (e.g. "permission-denied") if `error` is a FirebaseError. */
export function getFirebaseErrorCode(error: unknown): string | undefined {
  return error instanceof FirebaseError ? error.code : undefined;
}
